import { Map, fromJS } from 'immutable';

import * as c from 'common/constants';

const initialSettingsState = new Map();

export const settingsReducer = (state = initialSettingsState, action) => {
  switch (action.type) {
    case c.SET_SETTINGS: {
      const { app, settings } = action;

      return state.set(app, fromJS(settings));
    }

    default:
      return state;
  }
};

export default settingsReducer;



// WEBPACK FOOTER //
// ./src/common/reducers/settingsReducer.js